<template>
  <div class="data-center">
    <el-row>
      <div class="chart6-content">
        <div>
          <span style="float: left; display: inline-block;margin-top: 10px;">微信行为分析</span>
          <el-button class="el-icon-download" style="float: right; margin-top:20px; margin-right: 30px;"></el-button>
          <el-select v-model="eventValue" placeholder="请选择" class="trigger-event-select">
            <el-option
              v-for="item in eventOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              class="public-number">
            </el-option>
          </el-select>
          <el-select v-model="publicNumberValue" placeholder="全部公众号" class="public-number-select">
            <el-option
              v-for="item in publicNumber"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              class="public-number">
            </el-option>
          </el-select>
          <el-date-picker
            v-model="value4"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="data-center-select">
          </el-date-picker>
          <div class="order-calendar">
            <ul>
              <li @click="getDataDay()" v-bind:class="{ active: isOrderD}">今日</li>
              <li @click="getDataWeek()" v-bind:class="{ active: isOrderW}">本周</li>
              <li @click="getDataMonth()" v-bind:class="{ active: isOrderM}">本月</li>
            </ul>
          </div>
        </div>
        <div id="chart6" class="chart6"></div>
      </div>
    </el-row>
  </div>
</template>
<script>
import { regionData, CodeToText } from 'element-china-area-data'
export default {
  name: 'dataCenter',
  data () {
    return {
      input: '',
      checkAll: false,
      checkedCities: ['上海', '北京'],
      cities: ['上海', '北京', '广州', '深圳'],
      isIndeterminate: true,
      sss: '',
      publicNumber: [
        {
          value: '选项1',
          label: '哈哈虎'
        },
        {
          value: '选项2',
          label: '景芝酒业'
        }
      ],
      eventOptions: [
        {
          value: '选项1',
          label: '关注公众号'
        },
        {
          value: '选项2',
          label: '取消关注公众号'
        },
        {
          value: '选项3',
          label: '向微信公众号留言'
        },
        {
          value: '选项3',
          label: '点击微信公众号菜单'
        },
        {
          value: '选项3',
          label: '扫微信公众号二维码'
        },
        {
          value: '选项3',
          label: '发送微信模板消息'
        },
        {
          value: '选项3',
          label: '发送微信红包'
        },
        {
          value: '选项3',
          label: '微信公众号向客服回复'
        }
      ],
      eventValue: '',
      publicNumberValue: '全部公众号',
      activeName: 'second',
      value4: '',
      isOrderD: true,
      isOrderW: false,
      isOrderM: false,
      isOrderY: false,
      chart1NameArray: [],
      chart1DataArray: [],
      optionss: regionData
    }
  },
  methods: {
    addLine() {
      this.tableData.push({
        date: '1',
        name: '王小虎'
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    },
    getDataDay() {
      this.isOrderD = true
      this.isOrderW = false
      this.isOrderM = false
      this.isOrderY = false
    },
    getDataWeek() {
      this.isOrderD = false
      this.isOrderW = true
      this.isOrderM = false
      this.isOrderY = false
    },
    getDataMonth() {
      this.isOrderD = false
      this.isOrderW = false
      this.isOrderM = true
      this.isOrderY = false
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    chart6() {
      let myChart = this.$echarts.init(document.getElementById('chart6'))
      myChart.setOption({
        animation: true,
        title: {
          left: 'center',
          text: '触屏 tooltip 和 dataZoom 示例',
          subtext: '"tootip" and "dataZoom" on mobile device'
        },
        legend: {
          top: 'bottom',
          data: ['意向']
        },
        tooltip: {
          triggerOn: 'none',
          position: function (pt) {
            return [pt[0], 130]
          }
        },
        toolbox: {
          left: 'center',
          itemSize: 25,
          top: 55,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {}
          }
        },
        xAxis: {
          type: 'time',
          // boundaryGap: [0, 0],
          axisPointer: {
            value: '2016-10-7',
            snap: true,
            lineStyle: {
              color: '#004E52',
              opacity: 0.5,
              width: 2
            },
            label: {
              show: true,
              formatter: function (params) {
                return echarts.format.formatTime('yyyy-MM-dd', params.value)
              },
              backgroundColor: '#004E52'
            },
            handle: {
              show: true,
              color: '#004E52'
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            inside: true
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            inside: true,
            formatter: '{value}\n'
          },
          z: 10
        },
        grid: {
          top: 110,
          left: 15,
          right: 15,
          height: 160
        },
        dataZoom: [{
          type: 'inside',
          throttle: 50
        }],
        series: [
          {
            name: '模拟数据',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            sampling: 'average',
            itemStyle: {
              normal: {
                color: '#8ec6ad'
              }
            },
            stack: 'a',
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#8ec6ad'
                },
                {
                  offset: 1,
                  color: '#ffe'
                }])
              }
            },
            data: data
          }
        ]
      })
    }
  },
  mounted() {
    this.chart6()
  },
  created() {
  },
  components: {
  }
}
</script>

<style scoped>
.chart6-content {
  margin-top: 10px;
  float: left;
  width: 100%;
  height: 450px;
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  padding-bottom: 50px;
}
.chart6 {
  float: left;
  width: 100%;
  height: 100%;
}
.customer-distribute {
  width: 400px;
}
.data-el-menu {
  float: right;
  width: 320px;
  margin-left: 10px;
  margin-top: 10px;
}
.data-center-select {
  float: right;
  margin-top: 20px;
  margin-right: 20px;
  margin-left: 10px;
  width: 250px;
}
.public-number-select {
  float: right;
  margin-top: 20px;
  margin-right: 30px;
  width: 120px;
}
.trigger-event-select {
  float: right;
  margin-top: 20px;
  margin-right: 80px;
  width: 170px;
}
.order-calendar {
  width: 257px;
  height: 30px;
  float: right;
}
.customer-value {
  width: 500px;
  height: 30px;
  float: right;
}
.order-calendar ul ,.customer-value ul {
  display: inline-block;
  float: right;
  margin: 0;
  margin-right: 10px;
}
.order-calendar ul li,.customer-value ul li {
  float: left;
  width: auto;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 15px;
  display: inline-block;
  margin-top: 0px;
}
.order-calendar ul li.active,.customer-value ul li.active {
  color: #1890FF;
  border-bottom: 1px solid #1890FF;
}

</style>
